module.exports = __webpack_public_path__ + "static/media/logo.54015fe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 265
// module chunks = 0